<template>
  <div class='inside-component party-build-course'>
    <div class="container-water-fall">
      <waterfall :col='2' :data="courseList" @loadmore="loadmore" @scroll="scroll">
        <template>
          <div class="cell-item" v-for="(item,index) in courseList" :key="index">
            <div class="item" @click="toDetailPage(item)">
              <img :src="formatAliyunPath(item.coverImg)+'?x-oss-process=image/resize,p_50'" />
              <div class="session-contain">
                <h3 v-text="item.name"></h3>
                <p v-text="item.summary"></p>
              </div>
            </div>
          </div>
        </template>
      </waterfall>
    </div>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
import Dict from '@/core/dict'
export default {
  name: 'ModelCourse',
  props: {
    courseList: { // 列表
      default: []
    },
    tabIndex: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
    }
  },
  components: {},
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 布局
    scroll (scrollData) {
    },
    loadmore (index) {
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
    toDetailPage (item) {
      console.log(this.tabIndex)
      this.$router.push({
        path: '/course/detail',
        query: {
          id: item.id,
          backPath: 'course',
          type: Dict.pageType.inform,
          tabIndex: this.tabIndex
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
.party-build-course{
   .cell-item{
       margin-bottom: 10px;
    }
    .item{
    background: #fff;
    border-radius: 2px;
    overflow: hidden;
    img {
      width: 100%;
      min-height: 91px;
      height: auto;
      vertical-align:bottom;
    }
    .session-contain{
          h3{
           font-size: 13px;
           font-family: YouSheBiaoTiHei;
           font-weight: 600;
           color: #252525;
           line-height: 18px;
           margin-bottom: 8px;
           text-overflow: -o-ellipsis-lastline;
           overflow: hidden;
           text-overflow: ellipsis;
           display: -webkit-box;
           -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        p{
                font-size: 10px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #828282;
                line-height: 15px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
        }
        }
     }
}
</style>
<style lang='scss'>
.party-build-course{
 .container-water-fall {
    padding: 20px;
    width:100%;
    box-sizing: border-box;
  }
  .cell-item {
    background: #f2f2f2 !important;
    overflow: hidden;
    box-sizing: border-box;
  }
  .cell-item img {
    width: 100%;
    height: auto;
    display: block;
  }
  .vue-waterfall-column:nth-child(2){
    .item{margin-right: 5px;}
    .session-contain{padding: 23px 20px 25px 13px;}
  }
  .vue-waterfall-column:last-child{
       .item{margin-left: 5px;}
       .session-contain{padding: 11px 20px 12px 13px;}
  }
}
</style>
